import React from "react";
import Meaning from "./Meaning";
import Phonetic from "./Phonetic";

export default function Result(props) {
    if (props.results) {
        return (
            <div className="Results">
                <section>
                <h2 className="text-start display-5 py-3 fw-bold">{props.results.word}</h2>
                {props.results.phonetics.map(function(phonetic, index){
                    return (
                        <div key={index}>
                            <Phonetic phonetic={phonetic} />
                        </div>
                    )
                })}
                </section>
                {props.results.meanings.map(function (meaning, index) {
                   return <div key={index}>
                    <section>
                    <Meaning meaning={meaning}/>
                    </section>
                   </div>
                })}
            </div>
        );
    }
    else {
        return null;
    }
}